/* eslint-disable */

<template>
	<div id="disclaimers-content" class="disclaimers-content" :key="userId">
		<AlertMessage
			:showAlertMessage="isLocked"
			alertClass="error"
			:hideClose="true"
			alertMessage="Please select and save your license(s) and compliance logo in order to enable your Brand 360 access."
			@handle-close="resetShowAlert"
		></AlertMessage>
		<Modal
			modalTitle="Confirmation"
			actionBtnName="Close"
			class="lg legal-modal disable-cancel"
			v-if="showModal"
			@close="showModal = false"
			@clicked="
				() => (hasAccessToClientConnect ? modalClosed() : (showModal = false))
			"
		>
			<div slot="modalContent">
				<p>
					Congratulations! Your disclaimer and compliance logo have been saved.
					You and your borrowers are now opted-in to receive automatic email
					communications for all Client Connect alerts. To review or change
					these settings, please visit the Alerts page in the Preference Center.
				</p>
			</div>
		</Modal>

		<div v-if="isLocked" class="disclaimer-alert" role="alert">
			Please select and save your license(s) and compliance logo in order to
			enable your Brand 360 access.
		</div>
		<section
			class="preference-center-section b360-grid-row"
			v-for="section in disclaimerSections"
			:key="section.id"
		>
			<TitleDescription
				class="b360-col-xs-12 b360-col-sm-12 b360-col-md-4"
				:title="section.title"
				:description="section.description"
			>
			</TitleDescription>

			<div
				v-if="section.licenses"
				class="b360-col-xs-12 b360-col-sm-12 b360-col-md-4"
			>
				<label class="b360-form-label license-label" for="license-list">
					Available Licenses
					<font-awesome-icon
						class="asterisk"
						:icon="['fas', 'asterisk']"
						v-tooltip="{
							content: 'This is a required field',
							trigger: 'hover click',
							placement: 'top-end',
						}"
					/>
					<ToggleSwitch
						v-if="!roleIsNotActive('EditLicensingDisclaimerInformation')"
						@click="toggleAllLicenses"
						class="toggle-switch--toggle-all"
						:class="getAllLicensesOn"
						v-model="getAllLicensesOn"
					></ToggleSwitch>
					<ToggleSwitch
						v-else
						class="toggle-switch--toggle-all"
						:class="getAllLicensesOn"
						v-model="getAllLicensesOn"
						:disabled="roleIsNotActive('EditLicensingDisclaimerInformation')"
					></ToggleSwitch>
				</label>

				<ul
					id="license-list"
					class="license-list license-list--preference-center"
					role="listbox"
				>
					<li
						v-for="(license, index) in licenseList"
						:key="index"
						class="license-item"
						role="option"
						:id="`license-${index}`"
						@click="
							!roleIsNotActive('EditLicensingDisclaimerInformation')
								? selectLicense(index)
								: ''
						"
						:disabled="roleIsNotActive('EditLicensingDisclaimerInformation')"
					>
						{{ license.state }} - {{ license.licenseName }} ({{
							license.agencyTypeDesc
						}})
						<ToggleSwitch
							:class="license.isSelected"
							v-model="licenseList[index].isSelected"
							:disabled="roleIsNotActive('EditLicensingDisclaimerInformation')"
						></ToggleSwitch>
					</li>
				</ul>
			</div>

			<div
				v-if="section.licenses"
				class="b360-col-xs-12 b360-col-sm-12 b360-col-md-4"
			>
				<label class="b360-form-label disclaimer-label" for="preview-content">
					Disclaimer Preview
					<FormLabelTooltip
						:tooltip="`Update the requested information in the [brackets] below to finalize your disclaimer.`"
					/>
				</label>
				<div class="preview-content--wrapper">
					<textarea
						:value="disclaimerText"
						@keypress.enter.prevent
						@input="setDisclaimerPreview"
						class="preview-content"
						name="preview-content"
						id="preview-content"
						:disabled="roleIsNotActive('EditLicensingDisclaimerInformation')"
					></textarea>
				</div>
			</div>

			<ComplianceLogos
				class="b360-col-xs-12 b360-col-sm-12 b360-col-md-8"
				v-else
				:logoList="logoList"
				:selectedLogos="selectedLogoIds"
				:disabledClass="roleIsNotActive('EditAComplianceLogo')"
				@handle-click="selectLogo"
				:key="userId"
			></ComplianceLogos>
		</section>

		<SaveButton
			:waiting="saveState.saving"
			:saved="saveState.saved"
			@handle-click="save"
			:disabled="!complianceCriteriaSatisfied || disableSave"
		></SaveButton>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import TitleDescription from '@/components/global/TitleDescription.vue';
import ToggleSwitch from '@/components/global/ToggleSwitch.vue';
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';
import SaveButton from '@/components/preference-center/SaveButton';
import AlertMessage from '@/components/global/AlertMessage.vue';
import ComplianceLogos from '@/components/preference-center/ComplianceLogos.vue';
import Modal from '@/components/global/Modal.vue';
import profileService from '@/services/profile/profile-service';

export default {
	name: 'PreferenceCenterDisclaimers',
	components: {
		TitleDescription,
		ToggleSwitch,
		FormLabelTooltip,
		SaveButton,
		AlertMessage,
		ComplianceLogos,
		Modal,
	},
	computed: {
		...mapState({
			licenseList: (state) => state.licenses.list,
			disableSave: (state) =>
				state.profileSwitcher.profileSelector.isInternalUser,
			// refactor into a getter (or getters)
			logoList: (state) => {
				if (!state.companyProfile.licenses) return [];
				if (
					!state.companyProfile.licenses.some(
						(license) =>
							license.licenseKey == 'MA' || license.licenseKey == 'string',
					) &&
					state.complianceLogos.logosList.some(
						(el) => el.title == 'complanceLogoType6',
					)
				) {
					return state.complianceLogos.logosList.slice(
						0,
						state.complianceLogos.logosList.length - 3,
					);
				}

				if (
					state.companyProfile.licenses.some(
						(license) =>
							license.licenseKey == 'MA' || license.licenseKey == 'string',
					) &&
					state.companyProfile.institutionType !== 'CreditUnion'
				) {
					return state.complianceLogos.logosList.slice(
						0,
						state.complianceLogos.logosList.length - 2,
					);
				}

				return state.complianceLogos.logosList;
			},
			// refactor into a getter (or getters)
			getAllLicensesOn: (state) =>
				state.licenses.list.every((el) => el.isSelected === true),
			// refactor into a getter (or getters)
			disclaimerText: (state) => {
				let text = '';
				const selectedItems = state.licenses.list.filter(
					(license) => license.isSelected === true,
				);
				selectedItems.forEach((el) => {
					text += el.disclaimerText + '\n';
				});
				return text.replace(/\r?\n$/, '');
			},
			contactId: (state) => state.profile.contactId,
			// refactor into a getter (or getters)
			selectedLogoIds: (state) =>
				state.complianceLogos.selectedLogos.map((el) => parseInt(el.value)),
			// refactor into a getter (or getters)
			selectedLogos: (state) => state.complianceLogos.selectedLogos,
			licenses: (state) => state.licenses,
			logos: (state) => state.complianceLogos,
			isInternalUser: (state) =>
				state.profileSwitcher.mainProfileSelector.isInternalUser,
			// refactor into a getter (or getters)
			isLocked: (state) =>
				!state.licenses.disclaimerTextSelected ||
				!state.complianceLogos.complianceLogoSelected,
			userId: (state) => state.profile.userId,
			alerts: (state) => state.userAlerts.preferences,
		}),
		...mapGetters([
			'isValidPreferences',
			'hasAccessToClientConnect',
			'roleIsNotActive',
		]),
		complianceCriteriaSatisfied() {
			return (
				this.licenseList.some((el) => el.isSelected === true) &&
				this.selectedLogos.length > 0
			);
		},
	},
	methods: {
		...mapActions([
			'resetShowAlert',
			'selectLicense',
			'selectLogo',
			'saveLogos',
			'toggleAllLicenses',
			'setDisclaimerPreview',
			'saveAllDisclaimerLicenses',
			'saveAlerts',
		]),

		async save() {
			this.saveState.saving = true;
			if (
				document.getElementById('preference-center-form').reportValidity() &&
				this.selectedLogoIds.length > 0
			) {
				const contactId = this.contactId;
				const selectedLogos = this.selectedLogos;
				const preferencesSavedPreviously = this.isValidPreferences();
				const licenseSave = await this.saveAllDisclaimerLicenses(contactId);
				const logoSave = await this.saveLogos({
					contactId,
					selectedLogos,
				});

				if (licenseSave === true && logoSave === true) {
					this.saveState.saving = false;
					this.saveState.saved = true;
					if (!preferencesSavedPreviously) {
						this.showModal = true;
					}
				} else {
					this.saveState.saving = false;
				}
			} else {
				this.saveState.saving = false;
				const formElements = document.querySelectorAll('input, select');
				formElements.forEach((el) => {
					el.addEventListener('invalid', function () {
						this.scrollIntoView(false);
					});
				});
			}

			setTimeout(() => {
				this.saveState.saving = false;
				this.saveState.saved = false;
			}, 1000);
		},
		async modalClosed() {
			this.alerts.forEach((p) => {
				if (
					p.name === 'ReviewMe' ||
					p.name === 'VideoReview' ||
					p.name === 'VideoReviewSMS'
				) {
					p.isOptedIn = false;
					p.isAutoScheduled = false;
				} else {
					p.isOptedIn = true;
					p.isAutoScheduled = true;
				}
				if (p.recipientNotifications) {
					let notifications = p.recipientNotifications.flatMap(
						(n) => n.notifications,
					);
					notifications.forEach((n) => {
						n.activeInd = n.notificationType === 'Email';
					});
				}
			});

			try {
				await this.saveAlerts({
						contactId: this.contactId,
						preferences: this.preferences,
					});
			} catch (error) {
				console.error(error);
			}

			this.showModal = false;
		},
	},
	data() {
		return {
			disclaimerSections: [
				{
					id: 1,
					title: 'Licensing',
					description:
						"Choose the licenses applicable to your business and to your state's requirements.",
					licenses: true,
				},
				{
					id: 2,
					title: 'Compliance Logos',
					description:
						"Include the appropriate logo on your marketing materials per your state's laws.",
					logos: true,
				},
			],
			saveState: {
				saving: false,
				saved: false,
			},
			shouldShowAlert: false,
			showModal: false,
		};
	},
	beforeRouteLeave(to, from, next) {
		if (this.licenses.isEdited === true || this.logos.isEdited === true) {
			let editedItem;
			if (this.licenses.isEdited === true && this.logos.isEdited === true) {
				editedItem = 'Licensing and Compliance Logo';
			} else if (this.licenses.isEdited === true) {
				editedItem = 'Licensing';
			} else {
				editedItem = 'Compliance Logo';
			}

			const answer = window.confirm(
				`There are unsaved ${editedItem} changes.  Are you sure you want to continue?`,
			);
			// if the user has edited data and elects to navigate away without saving we rehydrate the store
			// with what was saved in the database
			if (answer === true) {
				profileService.getProfile();
				this.$store.commit('LICENSES_ISEDITED');
				this.$store.commit('LOGOS_ISEDITED');
			}
			next(answer);
		} else {
			next();
		}
	},
	mounted() {
		this.licenses.isEdited = false;
		this.logos.isEdited = false;
	},
};
</script>

<style scoped lang="scss">
.asterisk {
	@include rem('margin', -10px auto 0 0);
	color: $brand-blue;
	font-size: $b360-font-size--smallest;
}

.preference-center-section {
	@include rem('padding', 10px 0);
	border-bottom: 1px solid $border-color-light;

	&:first-of-type {
		@include rem('padding-bottom', 25px);

		.title-description {
			grid-row-end: 1;
		}
	}

	&:last-of-type {
		border: none;
	}
}

.license-item {
	min-height: 20%;
}

@include lg {
	.license-list {
		@include rem('height', 300px);
	}

	.preview-content {
		@include rem('height', 280px);
	}
}

.title-description {
	grid-row-start: 1;
	grid-row-end: span 3;

	@include lg {
		@include rem('padding-right', 25px);
	}
}

.license-label {
	@include flex-center;
	justify-content: space-between;
}

.toggle-switch--toggle-all {
	@include rem(margin-right, 15px);
}

.disclaimer-label {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.disclaimer-alert {
	position: relative;
	padding: 0.75rem 1.25rem;
	margin-bottom: 1rem;
	border: 1px solid transparent;
	border-radius: 0.25rem;
	color: #004085;
	background-color: #cce5ff;
	border-color: #b8daff;
}
</style>
